"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMeetingByIdResponseDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
class CompanyDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company ID", example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company name", example: "ABC Corp" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "name", void 0);
class OpportunityDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Opportunity ID", example: 1 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Opportunity name",
        example: "New Business Opportunity",
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityDto.prototype, "name", void 0);
class MeetingTypeDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Meeting Type ID", example: 2 }),
    tslib_1.__metadata("design:type", Number)
], MeetingTypeDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Meeting Type name", example: "Client Meeting" }),
    tslib_1.__metadata("design:type", String)
], MeetingTypeDto.prototype, "name", void 0);
class ParticipantDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Participant name", example: "John Doe" }),
    tslib_1.__metadata("design:type", String)
], ParticipantDto.prototype, "name", void 0);
class GetMeetingByIdResponseDto {
}
exports.GetMeetingByIdResponseDto = GetMeetingByIdResponseDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Meeting ID", example: 1 }),
    tslib_1.__metadata("design:type", Number)
], GetMeetingByIdResponseDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Meeting Date", example: "2025-05-10" }),
    tslib_1.__metadata("design:type", String)
], GetMeetingByIdResponseDto.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Start Time", example: "2025-05-10T10:00:00Z" }),
    tslib_1.__metadata("design:type", String)
], GetMeetingByIdResponseDto.prototype, "startTime", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "End Time", example: "2025-05-10T11:00:00Z" }),
    tslib_1.__metadata("design:type", String)
], GetMeetingByIdResponseDto.prototype, "endTime", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting location",
        example: "Conference Room A",
    }),
    tslib_1.__metadata("design:type", String)
], GetMeetingByIdResponseDto.prototype, "location", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Minutes of the meeting",
        example: "Discussed project timelines and deliverables.",
    }),
    tslib_1.__metadata("design:type", String)
], GetMeetingByIdResponseDto.prototype, "minutesOfMeeting", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company details", type: CompanyDto }),
    tslib_1.__metadata("design:type", CompanyDto)
], GetMeetingByIdResponseDto.prototype, "company", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Opportunity details", type: OpportunityDto }),
    tslib_1.__metadata("design:type", OpportunityDto)
], GetMeetingByIdResponseDto.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Meeting Type details", type: MeetingTypeDto }),
    tslib_1.__metadata("design:type", MeetingTypeDto)
], GetMeetingByIdResponseDto.prototype, "meetingTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of participants",
        type: [ParticipantDto],
    }),
    tslib_1.__metadata("design:type", Array)
], GetMeetingByIdResponseDto.prototype, "participants", void 0);
